<script lang="jsx">
import { get } from 'lodash';
import {
  ADDON_GROUP,
  BASE_PLAN_SUB_TYPES,
  planTypes,
} from '@/common/constants';
import { getRecommendPlansFrom } from '@/common/product';
import { softBundleUtils } from '@/views/config/soft-bundle/helper';
import { hasZoomPhoneFreeTrialPlan } from '@/plans/ZOOM_PHONE/helper/utils';
import store from '@/store/index';
import Switch from './switch.vue';
import Add from './add.vue';

export default {
  props: {
    group: {
      type: String,
      default: ADDON_GROUP.DEFAULT,
    },
  },
  group() {
    const { type, sub_type } = get(getRecommendPlansFrom(store.getters.getSelectedPlans), [0], {});
    if (
      (window.$context.is.buyNow || window.$context.is.basic2pro) &&
      !softBundleUtils.isSoftProPlusBundle() &&
      type === planTypes.ZOOM_MEETING &&
      sub_type === BASE_PLAN_SUB_TYPES.PRO
    ) {
      return [ADDON_GROUP.WIN_BACK, ADDON_GROUP.DEFAULT];
    }
    return [ADDON_GROUP.WIN_BACK];
  },
  for() {
    // Hide addon if user has Zoom Phone free trial plan
    if (hasZoomPhoneFreeTrialPlan()) {
      return false;
    }
    // Hide addon if user select pro plan
    if (store.getters.activeProToBizBanner) {
      return false;
    }
    return true;
  },
  render() {
    const context = {
      ...this.$attrs,
      ...this.$props,
      group: this.group,
    };
    if (this.group === ADDON_GROUP.WIN_BACK) {
      return <Add {...context} />;
    };
    return <Switch {...context} />;
  },
};
</script>
